module.exports = __webpack_public_path__ + "img/tablet_cover_b.732ae10b.png";